import React from "react";
import rocket from '../Images/Rocket.png'
import sparkle from '../Images/Sparkle.png'
import rectangle from '../Images/Rectangle31.png'
import rectangl from '../Images/Rectangle32.png'
import rectang from '../Images/Rectangle33.png'
import rectan from '../Images/Rectangle34.png'
import { motion } from "framer-motion";

const Sectwo = () => {

    const background ={
        background: '#F5F5F5',
        marginTop: '70px',
    }
    const glideLeft = {
        initial: { opacity: 0, x: 60 },
        whileInView: { opacity: 1, x: 0 },
        transition: { duration: 0.7 },
        viewport: { once: true }
    };
    const glideUp = {
        initial: { opacity: 0, y: 60 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.8 },
        viewport: { once: true }
    };

    const glideDown = {
        initial: { opacity: 0, y: -60 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.8 },
        viewport: { once: true }
    };

    return(
        <>
        <div style={background}>
          <div className="container">
            <div className="row g-4 mt-5">
                <div className="col-md-6 pb-5">
                <motion.div {...glideLeft}>
                    <div className="p-4" style={{ background: "white", borderRadius: "20px" }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h2 style={{ color: "#353995" }}>
                        <span style={{ fontSize: "100px", color: '#F29235' }}>.</span>Our Mission
                        </h2>
                        <img src={rocket} alt="" />
                    </div>

                    <p>
                        To democratize{" "}
                        <span style={{ color: "#F29235", fontWeight: "700" }}>
                        advanced digital tools
                        </span>{" "}
                        for B2B enterprises, ensuring that every piece of software we build
                        enhances productivity while maintaining a human touch.
                    </p>
                    </div>
                </motion.div>
                </div>

                <div className="col-md-6 pb-5">
                <motion.div {...glideLeft}>
                    <div className="p-4" style={{ background: "white", borderRadius: "20px" }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h2 style={{ color: "#353995" }}>
                        <span style={{ fontSize: "100px", color: '#353995' }}>.</span>Our Vision
                        </h2>
                        <img src={sparkle} alt="" />
                    </div>

                    <p>
                        To become the global benchmark for{" "}
                        <span style={{ color: '#F29235', fontWeight: '700' }}>
                        empathetic technology
                        </span>, where businesses are powered by digital ecosystems that feel
                        natural, intuitive, and truly supportive.
                    </p>
                    </div>
                </motion.div>
                </div>

            </div>
            </div>
        </div>

        <div className="container" style={{ marginTop: "70px" }}>
           <div className="row g-4">

                <div className="col-md-3">
                <motion.div {...glideUp}>
                <img src={rectangle} alt="" className="img-fluid w-100" />
                </motion.div>
                </div>

                <div className="col-md-3" style={{ marginTop: "150px" }}>
                <motion.div {...glideDown}>
                <img src={rectangl} alt="" className="img-fluid w-100" />
                </motion.div>
                </div>

                <div className="col-md-3">
                <motion.div {...glideUp}>
                <img src={rectang} alt="" className="img-fluid w-100" />
                </motion.div>
                </div>

                <div className="col-md-3" style={{ marginTop: "150px" }}>
                <motion.div {...glideDown}>
                <img src={rectan} alt="" className="img-fluid w-100" />
                </motion.div>
                </div>

           </div>
        </div>

        </>
    )
}

export default Sectwo;